import type { App } from "vue";
import "@/theme/theme.scss";
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";
import vueSmoothScroll from "vue3-smooth-scroll";
import { ObserveVisibility } from "vue-observe-visibility";
import { dragscroll } from "vue-dragscroll";

export function registerCorePlugins(app: App) {
  app.use(vueSmoothScroll, {
    duration: 300,
    updateHistory: false,
  });
  app.directive("observe-visibility", ObserveVisibility);
  app.directive("dragscroll", dragscroll);
  app.provide("breakpoints", {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 1024,
    xlg: 1040,
    xl: 1200,
    xxl: 1400,
  });
}
